import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkOrdersQuery } from '../state/workorders.query';
import { Observable, combineLatest, map, tap } from 'rxjs';
import { EmployeeDto, WorkOrderDto } from 'src/api';
import { MatListModule } from '@angular/material/list';
import { WorkOrdersRepository } from '../workorders.repository';
import { WorkorderCardComponent } from '../workorder-card/workorder-card.component';
import { WorkordersStateFilterComponent } from '../workorders-state-filter/workorders-state-filter.component';
import { WorkordersSearchComponent } from '../workorders-search/workorders-search.component';
import { animate, style, transition, trigger } from '@angular/animations';
import { TranslateModule } from '@ngx-translate/core';
import { EmployeesRepository } from 'src/employees/employees.repository';

@Component({
  selector: 'app-workorders-list',
  standalone: true,
  templateUrl: './workorders-list.component.html',
  styleUrls: ['./workorders-list.component.scss'],
  imports: [
    CommonModule,
    MatListModule,
    WorkorderCardComponent,
    WorkordersStateFilterComponent,
    WorkordersSearchComponent,
    TranslateModule,
  ],
  animations: [
    trigger('items', [
      transition(':enter', [
        style({ transform: 'scale(0.5)', opacity: 0 }), // initial
        animate('1s cubic-bezier(.8, -0.6, 0.2, 1.5)', style({ transform: 'scale(1)', opacity: 1 })),
      ]),
      transition(':leave', [
        style({ transform: 'scale(1)', opacity: 1, height: '*' }),
        animate(
          '1s cubic-bezier(.8, -0.6, 0.2, 1.5)',
          style({
            transform: 'scale(0.5)',
            opacity: 0,
            height: '0px',
            margin: '0px',
          })
        ),
      ]),
    ]),
  ],
})
export class WorkordersListComponent implements OnInit {
  animationsAreDisabled = true;
  workOrders$!: Observable<WorkOrderDto[]>;
  trigger: string = '';

  constructor(
    private workOrdersrepo: WorkOrdersRepository, 
    private workOrdersQuery: WorkOrdersQuery,
    private employeesrepo: EmployeesRepository, 
  ) {
    this.workOrders$ = combineLatest([
      this.workOrdersQuery.selectAll().pipe(
        tap(() => {
          this.trigger = 'selectWorkOrders';
        })
      ),
      this.workOrdersQuery.selectState$.pipe(
        tap(() => {
          this.trigger = 'selectState';
        })
      ),
      this.workOrdersQuery.selectSearchTerm$.pipe(
        tap(() => {
          this.trigger = 'selectSearchTerm';
        })
      ),
    ]).pipe(
      tap(() => {
        this.trigger == 'selectState' || this.trigger == 'selectSearchTerm'
          ? (this.animationsAreDisabled = true)
          : (this.animationsAreDisabled = false);
      }),
      map(([workOrders, state, searchTerm]) => {
        if (state && workOrders) {
          workOrders = (<WorkOrderDto[]>workOrders).filter((x) => x.workOrderState == state);
        }

        if (searchTerm) {
          workOrders = (<WorkOrderDto[]>workOrders).filter(
            (x) =>
              x.externalId?.includes(<string>searchTerm) ||
              x.clientName?.toLowerCase().includes((<string>searchTerm).toLocaleLowerCase()) ||
              x.clientAddress?.toLowerCase().includes((<string>searchTerm).toLocaleLowerCase())
          );
        }

        return <WorkOrderDto[]>(
          workOrders.sort(
            (a, b) =>
              Number(b.isBillable) - Number(a.isBillable) ||
              Number(a.clientValidation) - Number(b.clientValidation) ||
              new Date(b.expectedDate!).getTime() - new Date(a.expectedDate!).getTime()
          )
        );
      })
    );
  }

  ngOnInit(): void {
    this.workOrdersrepo.loadWorkOrders();
  }

  workOrderTrackBy(index: number, workOrder: WorkOrderDto) {
    return workOrder.id;
  }
}
